module.exports = __webpack_public_path__ + "img/tushuguan.1b7e7788.png";